module.exports = __webpack_public_path__ + "img/header-weddingRingsMokumeGane@2x.7ceeeac.webp";